import PropTypes from 'prop-types';

const FAQ_ARTICLE = {
  articleContent: PropTypes.string,
  articleId: PropTypes.string,
  articleTitle: PropTypes.string,
  topicId: PropTypes.string,
  breadCrumbPath: PropTypes.string,
  breadCrumbTitle: PropTypes.string,
};

const FAQ_ACTIVE_ARTICLE_CONTENT = {
  upfront_header: PropTypes.string,
  related_header: PropTypes.string,
};

const FAQ_RELATED_ARTICLE = {
  articleId: PropTypes.string,
  articleTitle: PropTypes.string,
  excerpt: PropTypes.string,
  rank: PropTypes.number,
};

const RELATED_ARTICLES = {
  articleId: PropTypes.string,
  articleTitle: PropTypes.string,
  topicId: PropTypes.string,
  topicName: PropTypes.string,
};

// Filtered Customer Service hour
const CUSTOMER_HOURS = {
  amPerCall: PropTypes.string,
  amTime1: PropTypes.string,
  amTime2: PropTypes.string,
  generalTime1: PropTypes.string,
  generalTime2: PropTypes.string,
  hoursOfService: PropTypes.string,
};

// Data shape of phone data filtered by `dataParser`
const CALL_US_CONTACT_INFO = {
  amFlag: PropTypes.string,
  amPhone: PropTypes.string,
  customerHour: PropTypes.shape(CUSTOMER_HOURS),
  generalMTS: PropTypes.string,
  generalPhoneNumber: PropTypes.string,
  header: PropTypes.string,
  mobileHeader: PropTypes.string,
  logoutInst: PropTypes.string,
  mobileLogoutInst: PropTypes.string,
  mtsPhone: PropTypes.string,
  phoneNumber: PropTypes.arrayOf(PropTypes.string),
  specialInstruction: PropTypes.string,
  webPin: PropTypes.string,
};

const CALL_US_PHONE_INFO = {
  isphonePresent: PropTypes.bool,
  phoneNumber: PropTypes.arrayOf(PropTypes.string),
  isInstructionPresent: PropTypes.bool,
  specialInstruction: PropTypes.string,
  showServiceHourHeader: PropTypes.bool,
  hoursOfService: PropTypes.string,
  webPin: PropTypes.string,
};

const CALL_US = {
  contactInfo: PropTypes.shape(CALL_US_PHONE_INFO),
};

const SELECT_RESULT = {
  topicId: PropTypes.string,
  topicName: PropTypes.string,
};

const WEBFORM_FIELDS_DETAILS = {
  character_limit: PropTypes.string,
  default_text: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
};

const WEBFORM_OTHER_FIELD_DETAILS = {
  topicId: PropTypes.string,
  kanaCode: PropTypes.string,
  topicName: PropTypes.string,
  subTopicName: PropTypes.string,
  pageflow: PropTypes.string,
};

const WEBFORM_ERRORS = {
  required: PropTypes.string,
  limit: PropTypes.string,
};

const SELECT_BOX_OPTIONS = {
  label: PropTypes.string,
  value: PropTypes.string,
};

const NOTIFIER_DETAILS_LINK_ITEM = {
  label: PropTypes.string,
  href: PropTypes.string,
  type: PropTypes.func,
};

const NOTIFIER_DETAILS = {
  title: PropTypes.string,
  description: PropTypes.string,
  iconClass: PropTypes.string,
};

const ALERT = {
  messageType: PropTypes.string,
  message: PropTypes.string,
};


const TAB = {
  key: PropTypes.string,
  label: PropTypes.string,
  priority: PropTypes.number,
  href: PropTypes.string,
};

const TOPICTREE_SEGMENT = {
  hide_topic: PropTypes.bool,
  leaf_node: PropTypes.bool,
  ref_id: PropTypes.string,
  topic_id: PropTypes.string,
  topic_name: PropTypes.string,
};

const TOPICTREE_SELECTION = Object.assign({}, TOPICTREE_SEGMENT, { sub_topics: PropTypes.array });

const TOPICTREE_RESULT = Object.assign({}, TOPICTREE_SEGMENT, { web_form_id: PropTypes.string });

const TOPICTREE = {
  display: PropTypes.bool,
  error: PropTypes.bool,
  isLoading: PropTypes.bool,
  topicTreeSelection: PropTypes.shape(TOPICTREE_SELECTION),
  topicTreeSelectionL1: PropTypes.shape(TOPICTREE_SELECTION),
  topicTreeSelectionL2: PropTypes.oneOfType([
    PropTypes.shape(TOPICTREE_RESULT),
    PropTypes.shape(TOPICTREE_SELECTION),
  ]),
  topicTreeSelectionL3: PropTypes.shape(TOPICTREE_RESULT),
};

const TOPICLAYERS = {
  layer1: PropTypes.string,
  layer2: PropTypes.string,
  layer3: PropTypes.string,
};

const TOPICSELECT = {
  layer: PropTypes.number,
  subTopics: PropTypes.array,
  topics: PropTypes.shape(TOPICLAYERS),
};

const QUICKANSWERS = {
  layer1: PropTypes.array,
  layer2: PropTypes.array,
};

const QUICKANSWERS_SELECTED = {
  layer1: PropTypes.string,
  layer2: PropTypes.string,
};

const TOP_REASON_TOPICS = {
  articleId: PropTypes.string,
  articleTitle: PropTypes.string,
  breadCrumbPath: PropTypes.string,
  breadCrumbTitle: PropTypes.string,
  channel: PropTypes.string,
  excerpt: PropTypes.string,
  rank: PropTypes.number,
  topicId: PropTypes.string,
  topicName: PropTypes.string,
  usage: PropTypes.number,
};

const ERROR_MESSAGE = {
  message: PropTypes.string,
  tryAgain: PropTypes.string,
};

const REF_SELECT_RESULT = {
  topicId: PropTypes.string,
  topicName: PropTypes.string,
  topicRefId: PropTypes.string,
};

const TOPIC_TREE_SELECT_RESULT = {
  topicTreeSelectResult: PropTypes.shape(REF_SELECT_RESULT),
  topicsDisplay: PropTypes.bool,
};

const SUB_TOPIC = {
  hide_topic: PropTypes.bool,
  leaf_node: PropTypes.bool,
  ref_id: PropTypes.string,
  topic_id: PropTypes.string,
  topic_name: PropTypes.string,
  web_form_id: PropTypes.string,
};

const CONTACT_OPTION = {
  type: PropTypes.string,
  priority: PropTypes.string,
};

const CRAWL_INTENT_SEARCH_TOPIC = {
  hide_topic: PropTypes.bool,
  leaf_node: PropTypes.bool,
  parents: PropTypes.arrayOf(PropTypes.string),
  ref_id: PropTypes.string,
  topic_id: PropTypes.string,
  topic_name: PropTypes.string,
  web_form_id: PropTypes.string,
};

const TOOLTIP_CONTENT_POSITION = {
  x: PropTypes.number,
  y: PropTypes.number,
};

const TAB_CONTENT = {
  label: PropTypes.string,
  logo: PropTypes.string,
  content: PropTypes.element,
  priority: PropTypes.number,
  onClick: PropTypes.func,
};

const LEXA_STATE = {
  loaded: PropTypes.bool,
  available: PropTypes.bool,
  waitTime: PropTypes.string,
};

const RACINFO = {
  request_a_call_enabled: PropTypes.bool,
};
const RAC = {
  loaded: PropTypes.bool,
  racInfo: PropTypes.shape(RACINFO),
};

const AVAILABLE_DECISION = {
  availability_decision: PropTypes.string,
  name: PropTypes.string,
  rank: PropTypes.number,
};

module.exports = {
  FAQ_ARTICLE,
  FAQ_ACTIVE_ARTICLE_CONTENT,
  FAQ_RELATED_ARTICLE,
  CALL_US_CONTACT_INFO,
  CALL_US_PHONE_INFO,
  CALL_US,
  SELECT_RESULT,
  WEBFORM_FIELDS_DETAILS,
  WEBFORM_OTHER_FIELD_DETAILS,
  WEBFORM_ERRORS,
  SELECT_BOX_OPTIONS,
  NOTIFIER_DETAILS,
  NOTIFIER_DETAILS_LINK_ITEM,
  ALERT,
  TAB,
  TOPICTREE,
  TOPICSELECT,
  TOPICLAYERS,
  QUICKANSWERS,
  QUICKANSWERS_SELECTED,
  TOP_REASON_TOPICS,
  RELATED_ARTICLES,
  ERROR_MESSAGE,
  TOPIC_TREE_SELECT_RESULT,
  SUB_TOPIC,
  CONTACT_OPTION,
  REF_SELECT_RESULT,
  CRAWL_INTENT_SEARCH_TOPIC,
  TOOLTIP_CONTENT_POSITION,
  TAB_CONTENT,
  LEXA_STATE,
  RAC,
  AVAILABLE_DECISION,
};
